import React from 'react';
import dialog from '../../../common/utility/dialog';

import { Modal, Input, Form, Table, Checkbox, Divider, Tooltip, Button, Select } from 'antd';
const { Option } = Select;
class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedValues: [],
            ventaPEN: 0,
            ventaUSD: 0,
            compraPEN: 0,
            compraUSD: 0
        }
    }

    handleCancel = () => {
        this.setState({ checkedValues:[]})
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    listaDocumento: this.fetchDocumentos(values),
                }
                this.props.onSave(form, this.props.form);
                this.setState({
                    checkedValues: []
                })
            }
        });
    }

    fetchDocumentos = (values) => {
        var result = [];

        if (values.arrIdTipoComprobante === undefined ||
            values.arrIdTipoRelacion === undefined ||
            values.arrIdCuentaContablePENVenta === undefined ||
            values.arrIdCuentaContablePENCompra === undefined ||
            values.arrIdCuentaContableUSDVenta === undefined ||
            values.arrIdCuentaContableUSDCompra === undefined
        )
            return result;

        var keys = [];
        var obj = Object.assign({}, values.arrIdCuentaContablePENVenta);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                idTipoComprobante: values.arrIdTipoComprobante[key],
                idTipoRelacion: values.arrIdTipoRelacion[key],
                idCuentaContablePENVenta: values.arrIdCuentaContablePENVenta[key] === undefined ? 0 : values.arrIdCuentaContablePENVenta[key].key,
                idCuentaContablePENCompra: values.arrIdCuentaContablePENCompra[key] === undefined ? 0 : values.arrIdCuentaContablePENCompra[key].key,
                idCuentaContableUSDVenta: values.arrIdCuentaContableUSDVenta[key] === undefined ? 0 : values.arrIdCuentaContableUSDVenta[key].key,
                idCuentaContableUSDCompra: values.arrIdCuentaContableUSDCompra[key] === undefined ? 0 : values.arrIdCuentaContableUSDCompra[key].key
            });
        });

        return result;
    };

    onChange = (value) => {
        console.log('checked = ', value);
        this.setState({ checkedValues: value });
    }

    onAplicar = () => {
        var newItem = [];
        if (this.state.checkedValues.length == 0) {
            dialog.error('Seleccione el tipo de relación.');
            return false;
        } else {

            this.props.form.setFieldsValue({
                'dataSource': []
            });
            this.props.formValues.data.forEach((item, index) => {

                var PenCompra = this.props.form.getFieldValue(`arrIdCuentaContablePENCompra[${item.identifier}]`);
                var UsdCompra = this.props.form.getFieldValue(`arrIdCuentaContableUSDCompra[${item.identifier}]`);
                var PenVenta = this.props.form.getFieldValue(`arrIdCuentaContablePENVenta[${item.identifier}]`);
                var UsdVenta = this.props.form.getFieldValue(`arrIdCuentaContableUSDVenta[${item.identifier}]`);

                if (this.state.checkedValues.includes(item.idTipoRelacion)) {
                    newItem.push({
                        id: 0,
                        idCuentaContablePENCompra: this.props.formValues.compraPEN == undefined ? item.idCuentaContablePENCompra : this.props.formValues.compraPEN,
                        idCuentaContableUSDCompra: this.props.formValues.compraUSD == undefined ? item.idCuentaContableUSDCompra : this.props.formValues.compraUSD,
                        idCuentaContablePENVenta: this.props.formValues.ventaPEN == undefined ? item.idCuentaContablePENVenta : this.props.formValues.ventaPEN,
                        idCuentaContableUSDVenta: this.props.formValues.ventaUSD == undefined ? item.idCuentaContableUSDVenta : this.props.formValues.ventaUSD,
                        idTipoComprobante: item.idTipoComprobante,
                        idTipoRelacion: item.idTipoRelacion,
                        identifier: item.identifier,
                        tipoRelacion: item.tipoRelacion,
                    });
                } else {



                    newItem.push({
                        id: 0,
                        idCuentaContablePENCompra: PenCompra == undefined ? 0 : PenCompra.key,
                        idCuentaContableUSDCompra: UsdCompra == undefined ? 0 : UsdCompra.key,
                        idCuentaContablePENVenta: PenVenta == undefined ? 0 : PenVenta.key,
                        idCuentaContableUSDVenta: UsdVenta == undefined ? 0 : UsdVenta.key,
                        idTipoComprobante: item.idTipoComprobante,
                        idTipoRelacion: item.idTipoRelacion,
                        identifier: item.identifier,
                        tipoRelacion: item.tipoRelacion,
                    });
                }

            });

            this.props.form.setFieldsValue({
                'dataSource': newItem
            });
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('dataSource', { initialValue: this.props.formValues.data });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Documento" : "Modificar Documento"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1200px"
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        disabled
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Codigo Sunat">
                                {getFieldDecorator('codigoSunat', {
                                    initialValue: this.props.formValues.codigoSunat
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        disabled
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <Divider orientation="left">Modificación masiva</Divider>

                    <div className="row">
                        <div className="col-md-3 form-group">

                            <Form.Item label="Ventas-PEN">
                                {getFieldDecorator(`ventaPEN`, {
                                    initialValue: this.props.formValues.ventaPEN ? { key: this.props.formValues.ventaPEN } : undefined
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Plan de Cuenta"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onCambio("ventaPEN", option == undefined ? 0 : option.key)}
                                        allowClear
                                    >
                                        {this.props.planesCuentaPENVenta.map(item => (
                                            <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">


                            <Form.Item label="Ventas-USD">
                                {getFieldDecorator(`ventaUSD`, {
                                    initialValue: this.props.formValues.ventaUSD ? { key: this.props.formValues.ventaUSD } : undefined
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Plan de Cuenta"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onCambio("ventaUSD",  option == undefined ? 0 : option.key)}
                                        allowClear
                                    >
                                        {this.props.planesCuentaUSDVenta.map(item => (
                                            <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Compra PEN">
                                {getFieldDecorator(`compraPEN`, {
                                    initialValue: this.props.formValues.compraPEN ? { key: this.props.formValues.compraPEN } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Plan de Cuenta"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onCambio("compraPEN",  option == undefined ? 0 : option.key)}
                                        allowClear
                                    >
                                        {this.props.planesCuentaPENCompra.map(item => (
                                            <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>

                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Compra USD">
                                {getFieldDecorator(`compraUSD`, {
                                    initialValue: this.props.formValues.compraUSD ? { key: this.props.formValues.compraUSD } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Plan de Cuenta"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onCambio("compraUSD",  option == undefined ? 0 : option.key)}
                                        allowClear
                                    >
                                        {this.props.planesCuentaUSDCompra.map(item => (
                                            <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <Divider orientation="left">Replicar En</Divider>

                        <div className="col-md-10 form-group">
                            {getFieldDecorator(`selectGroup`, {
                                initialValue: this.state.checkedValues
                            })(
                                <Checkbox.Group options={this.props.formValues.data} onChange={this.onChange} />
                            )}
                        </div>

                        <div className="col-md-2 form-group">
                            <Button
                                type="primary"
                                icon="check"
                                block
                                onClick={this.onAplicar}
                            >
                                Aplicar
                            </Button>
                        </div>
                    </div>
                    <Divider style={{ marginTop: 10 }} ></Divider>

                    {/* <div className="row"> */}
                    <Table
                        size="600px"
                        style={{ overflowX: 'auto' }}
                        rowKey={m => m.identifier}
                        dataSource={this.props.form.getFieldValue("dataSource")}
                        className={'table-documento'}
                        // pagination={{
                        //     pageSize: 10,
                        //     showTotal: (total) => `${total} Registro(s) encontrado(s).`
                        // }}
                        columns={[
                            // {
                            //     title: 'Opciones',
                            //     width: "100px",
                            //     key: 'options',
                            //     align: 'center',
                            //     render: (value, row) => (
                            //         <div className="custom-options">
                            //             <Tooltip placement="top" title={"Editar"}>
                            //                 <Button
                            //                     type="primary"
                            //                     icon="edit"
                            //                     size={"small"}
                            //                     onClick={() => this.props.onEdit(row)}
                            //                 />
                            //             </Tooltip>
                            //         </div>
                            //     )
                            // },
                            {
                                title: '',
                                dataIndex: 'idTipoComprobante',
                                width: 0,
                                key: 'idTipoComprobante',
                                render: (value, row) => {
                                    return (
                                        <div>
                                            {getFieldDecorator(`arrIdTipoComprobante[${row.identifier}]`, { initialValue: value })(
                                                <Input hidden />
                                            )}
                                        </div>
                                    );
                                }
                            },
                            {
                                title: '',
                                dataIndex: 'idTipoRelacion',
                                width: 0,
                                key: 'idTipoRelacion',
                                render: (value, row) => {
                                    return (
                                        <div>
                                            {getFieldDecorator(`arrIdTipoRelacion[${row.identifier}]`, { initialValue: value })(
                                                <Input hidden />
                                            )}
                                        </div>
                                    );
                                }
                            },
                            {
                                title: 'Tipo de Relacion',
                                dataIndex: 'tipoRelacion',
                                key: 'tipoRelacion',
                                width: "120px",
                            },
                            {
                                title: 'Ventas',
                                className: 'parent-group',
                                children: [
                                    {
                                        title: 'PEN',
                                        dataIndex: 'idCuentaContablePENVenta',
                                        key: 'idCuentaContablePENVenta',
                                        className: 'child-group',
                                        width: "250px",
                                        render: (value, row) => {
                                            return (
                                                <Form.Item>
                                                    {getFieldDecorator(`arrIdCuentaContablePENVenta[${row.identifier}]`, {
                                                        initialValue: value ? { key: value } : undefined,
                                                        validateTrigger: ['onChange']
                                                    })(
                                                        <Select showSearch labelInValue
                                                            placeholder={"Seleccione Plan de Cuenta"}
                                                            optionFilterProp="children"
                                                            allowClear
                                                        >
                                                            {
                                                                this.props.planesCuentaPENVenta.map(item => (
                                                                    <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                                                ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>

                                            );
                                        }
                                    },
                                    {
                                        title: 'USD',
                                        dataIndex: 'idCuentaContableUSDVenta',
                                        key: 'idCuentaContableUSDVenta',
                                        className: 'child-group',
                                        width: "250px",
                                        render: (value, row) => {
                                            return (
                                                <Form.Item>
                                                    {getFieldDecorator(`arrIdCuentaContableUSDVenta[${row.identifier}]`, {
                                                        initialValue: value ? { key: value } : undefined,
                                                        validateTrigger: ['onChange']
                                                    })(
                                                        <Select showSearch labelInValue
                                                            placeholder={"Seleccione Plan de Cuenta"}
                                                            optionFilterProp="children"
                                                            allowClear
                                                        >
                                                            {
                                                                this.props.planesCuentaUSDVenta.map(item => (
                                                                    <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                                                ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>

                                            );
                                        }
                                    },
                                ]
                            },
                            {
                                title: 'Compras',
                                className: 'parent-group',
                                children: [
                                    {
                                        title: 'PEN',
                                        dataIndex: 'idCuentaContablePENCompra',
                                        key: 'idCuentaContablePENCompra',
                                        className: 'child-group',
                                        width: "250px",
                                        render: (value, row) => {
                                            return (
                                                <Form.Item>
                                                    {getFieldDecorator(`arrIdCuentaContablePENCompra[${row.identifier}]`, {
                                                        initialValue: value ? { key: value } : undefined,
                                                        validateTrigger: ['onChange']
                                                    })(
                                                        <Select showSearch labelInValue
                                                            placeholder={"Seleccione Plan de Cuenta"}
                                                            optionFilterProp="children"
                                                            allowClear
                                                        >
                                                            {
                                                                this.props.planesCuentaPENCompra.map(item => (
                                                                    <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                                                ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>

                                            );
                                        }
                                    },
                                    {
                                        title: 'USD',
                                        dataIndex: 'idCuentaContableUSDCompra',
                                        key: 'idCuentaContableUSDCompra',
                                        className: 'child-group',
                                        width: "250px",
                                        render: (value, row) => {
                                            return (
                                                <Form.Item>
                                                    {getFieldDecorator(`arrIdCuentaContableUSDCompra[${row.identifier}]`, {
                                                        initialValue: value ? { key: value } : undefined,
                                                        validateTrigger: ['onChange']
                                                    })(
                                                        <Select showSearch labelInValue
                                                            placeholder={"Seleccione Plan de Cuenta"}
                                                            optionFilterProp="children"
                                                            allowClear
                                                        >
                                                            {
                                                                this.props.planesCuentaUSDCompra.map(item => (
                                                                    <Option key={item.id} value={item.id}>{item.cuentaContable} - {item.nombre}</Option>
                                                                ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>

                                            );
                                        }
                                    },
                                ]
                            }
                        ]}

                    />
                    {/* </div> */}
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)